
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.667 14v-1.333A2.667 2.667 0 008 10H3.334a2.667 2.667 0 00-2.667 2.667V14M5.667 7.333a2.667 2.667 0 100-5.333 2.667 2.667 0 000 5.333zM13.333 5.333v4M15.333 7.333h-4","stroke":"#8F36FF","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    